import React, { useState } from "react";
import { Box, Button, Container, makeStyles } from "@material-ui/core";
import { toast } from 'react-toastify';

import CourseSearch from "./CourseSearch";
import TestSearch from "./TestSelect";
import { producaov2 } from "../../../../../../services/apis";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
  },
}));

export default function FilterOptions({
  selectedTest,
  selectedCourse,
  onChangeSelectedCourse,
  onChangeSelectedTest,
}) {
  const styles = useStyles();

  const [loadingResultDownload, setLoadingResultDownload] = useState(false);

  const handleChangeCourse = (course) => {
    if (selectedTest) {
      onChangeSelectedTest(undefined);
    }

    onChangeSelectedCourse(course);
  };

  const handleDownloadResults = async () => {
    setLoadingResultDownload(true);

    try {
      const response = await producaov2.post(
        `/admin/reports/test-results`,
        {
          testJSID: selectedTest?.id,
          courseID: selectedCourse?.id,
        }
      );

      window.open(response.data?.url, "_blank");
    } catch (error) {
      console.log(error);

      toast.error('Houve um erro ao tentar baixar os resultados, contate o suporte');
    } finally {
      setLoadingResultDownload(false);
    }
  };

  return (
    <Box className={styles.container}>
      <CourseSearch
        selectedCourse={selectedCourse}
        onChangeSelectedCourse={handleChangeCourse}
      />
      {!!selectedCourse && (
        <TestSearch
          courseID={selectedCourse.id}
          selectedTest={selectedTest}
          onChangeSelectedTest={onChangeSelectedTest}
        />
      )}
      {!!selectedCourse && !!selectedTest && (
        <Box display="flex" justifyContent="flex-end" py={1}>
          <Button
            variant="contained"
            color="primary"
            disabled={loadingResultDownload}
            onClick={handleDownloadResults}
          >
            {loadingResultDownload ? 'Gerando...' : 'Baixar resultados'}
          </Button>
        </Box>
      )}
    </Box>
  );
}
